import React, { useState, useEffect } from 'react';
import Title from '../../Text/Title/Title';
import { SubTitle } from '../../Text/Subtitle/SubTitle.tsx';
import { Button, Col, Form, FormGroup, Input, Label, Row, Table, } from 'reactstrap';
import { useNotification } from '../../../hooks/useNotification';
import { FillingBottle } from 'react-cssfx-loading';
import BigText from '../../Text/BigText/BigText';
import { IMetricItem } from '../../../interfaces/IMetric.tsx';
import useApiRequests from '../../../hooks/useApiRequests.tsx';
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
import { LineChart } from '../../LineChart/LineChart.tsx';
import { BsFillFileEarmarkBarGraphFill } from "react-icons/bs";
import { Tooltip } from 'react-tooltip'
import { jsPDF } from 'jspdf';
import html2canvas from 'html2canvas';
import './metrics.css';
import useChangeTextById from '../../../hooks/useChangeTextById.tsx';

enum EnumMetricType {
  NotSelected = "-1",
  Developer = "Desenvolvedor",
  Screening = "Triagem",
}

enum PeriodOption {
  Last7Days = "Last7Days",
  CurrentMonth = "CurrentMonth",
  Today = "Today",
  Last30Days = "Last30Days",
  AllTimeToDate = "AllTimeToDate",
  Custom = "Custom"
}

const periodOptions = [
  {key: PeriodOption.Last30Days, value: "Últimos 30 Dias" },
  {key: PeriodOption.CurrentMonth, value: "Mês atual" },
  {key: PeriodOption.Last7Days, value: "Últimos 7 dias" },
  {key: PeriodOption.Today, value: "Hoje" },  
  {key: PeriodOption.AllTimeToDate, value: "Todo o Tempo" },
  {key: PeriodOption.Custom, value: "Personalizado" }
]



export default function Metrics() {
  const { notify } = useNotification();
  const { loading, getMetrics, getReportData, getScreeningMetrics } = useApiRequests();


  const [metrics, setMetrics] = useState<IMetricItem[] | null>(null);
  const [period, setPeriod] = useState<string>(PeriodOption.Last30Days); // Sempre inicializar com o primeiro elemeno da lista periodOptions

  const [customDateRange, setCustomDateRange] = useState({
    startDate: new Date().toISOString().split('T')[0],
    endDate: new Date().toISOString().split('T')[0],
  });
  const [sortDirectionAssigned, setSortDirectionAssigned] = useState<'asc' | 'desc'>('desc');
  const [sortDirectionCompleted, setSortDirectionCompleted] = useState<'asc' | 'desc'>('desc');
  const [graphData, setGraphData] = useState(null);
  const [selectedMember, setSelectedMember] = useState(null);
  const [buttonText, setButtonText] = useState('Filtrar');


  const [metricType, setMetricType] = useState<string>(EnumMetricType.Developer);


  const handleDownloadPDF = () => {
    const chartRef = document.getElementById('chartCanvas');
    if(chartRef === null)return;

    html2canvas(chartRef).then((canvas) => {
      const imgData = canvas.toDataURL('image/png');
      const pdf = new jsPDF();
      pdf.addImage(imgData, 'PNG', 10, 10, 190, 100);
      pdf.save('chart.pdf');
    });
    setGraphData(null);
  };

  const handleGetReport = async (member: any) => {
    setSelectedMember(member)
    const data = await getReportData(member.id);
    setGraphData(data.data);

    setTimeout(() => {
      notify("PDF Gerado com sucesso! Aguarde um momento...", { type: "success" });
      handleDownloadPDF();
    }, 1500);
  }

  //Faz a request ao abrir a tela
  // useEffect(() => {
  //   const fetchData = async () => {
  //     const data = await getMetrics(period, customDateRange);
  //     setMetrics(JSON.parse(data.data));
  //     if (data.msg != null && data.msg != "") {
  //       notify(data.msg, { type: "alert" });
  //     }
  //   };
  //   fetchData();
  // }, []);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const selectedValue = event.target.value;
    setPeriod(selectedValue);
    setCustomDateRange({
      startDate: new Date().toISOString().split('T')[0],
      endDate: new Date().toISOString().split('T')[0],
    });
    
  };

  //Para usar o hook basta colocar o state como o buttonText
  useChangeTextById('button-filter', buttonText);
  
  const handleGetMetrics = async () => {

    try{
      if(metricType === EnumMetricType.NotSelected){
        notify("Você precisa selecionar um tipo de métrica", { type: "error" });
        return;
      }
      setButtonText('Filtrando');

      let periodData = period == "Personalizado" ? "000" : period
      console.log(customDateRange, periodData)
      const data = 
        (metricType === EnumMetricType.Developer) ? 
        await getMetrics(periodData, customDateRange, "false") :
        await getScreeningMetrics(period == "Personalizado" ? "" : period, customDateRange) 
        
      if (data?.msg != null && data.msg != "") {
        notify(data.msg, { type: "error" });
      }

      if(data.data == "")return;
      setMetrics(JSON.parse(data?.data));
    }catch(error){
      console.error("err", error);


    }finally{
      setButtonText('Filtrar');
    }
  };

  const handleCustomDateChange = (field: 'startDate' | 'endDate', value: string) => {
    setCustomDateRange((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleOrderByCompleted = (sortDirection: any) => {
    const data = metrics;
    const sorted = data?.sort((a, b) => {
      const comparison = b.Metrics.TotalCompletedTasks - a.Metrics.TotalCompletedTasks;
      return sortDirection === 'asc' ? comparison : -comparison;
    });

    setSortDirectionCompleted(sortDirection === 'asc' ? 'desc' : 'asc');
    setMetrics(sorted || null );
  }

  const handleOrderByAssigned = (sortDirection: any) => {
    const data = metrics;
    const sorted = data?.sort((a, b) => {
      const comparison = b.Metrics.TotalTasks - a.Metrics.TotalTasks;
      return sortDirection === 'asc' ? comparison : -comparison;
    });

    setSortDirectionAssigned(sortDirection === 'asc' ? 'desc' : 'asc');
    setMetrics(sorted || null);
  }

  const handleMetricType = (metricType: string) => {
    setMetricType(metricType)
  }

  useEffect(()=> {
  },[metricType])

  const handleGoBack = () => {
    const lastHref = localStorage.getItem("lastHref");
    window.location.href = lastHref || "";
  };

  return (
    <div className='page-container'>
      <Row>
      <Col md={6}>
        <Tooltip id="metric-tooltip" />
        <Title>Métricas</Title>
      </Col>

      <Col md={6} className="d-flex justify-content-end">
          <Button
                className='me-3'
                color="secondary"
                style={{ height: "44px" }}
                onClick={() => handleGoBack()}
              >
                Voltar
              </Button>
        </Col>
      </Row>


      {/* <SubTitle>Desenvolvedores</SubTitle> */}
      <div className='mt-5'>
        <Row className='filters'>
          <Form>
            <Row>
              <Col md={4}>
                <FormGroup>
                  <Label for="period-select">
                    Filtrar por:
                  </Label>
                  <Input
                    id="period-select"
                    name="select"
                    type="select"
                    onChange={handleChange}
                    
                    value={period}
                  >
                    {periodOptions.map((element, index) => {
                      return (
                        <option key={index} value={element.key}>
                          {element.value}
                        </option>
                      )
                    })}

                  </Input>
                </FormGroup>

                
              </Col>


              <Col md={4}>
              <FormGroup>
                  <Label for="metric-type">
                    Tipo de métrica:
                  </Label>
                  <Input
                    id="metric-type"
                    name="select"
                    type="select"
                    onChange={(e) => {handleMetricType(e.target.value)}}
                    value={metricType}
                  >
                  {/* <option value={EnumMetricType.NotSelected}>Selecione</option> */}
                  <option value={EnumMetricType.Developer}>Desenvolvedor</option>
                  <option value={EnumMetricType.Screening}>Triagem</option>

                  </Input>
                </FormGroup>
              
              </Col>
            </Row>
            {period === PeriodOption.Custom && (
              <Row>
                <Col md={4}>
                  <FormGroup>
                    <Label for="init-date">
                      De
                    </Label>
                    <Input
                      id="init-date"
                      name="date"
                      placeholder="date placeholder"
                      type="date"
                      onChange={(event) => handleCustomDateChange('startDate', event.target.value)}
                      value={customDateRange.startDate}
                    />
                  </FormGroup>
                </Col>
                <Col md={4}>
                  <FormGroup>
                    <Label for="end-date">
                      Até
                    </Label>
                    <Input
                      id="end-date"
                      name="date"
                      placeholder="date placeholder"
                      type="date"
                      onChange={(event) => handleCustomDateChange('endDate', event.target.value)}
                      value={customDateRange.endDate}
                    />
                  </FormGroup>
                </Col>
              </Row>
            )}
            <Row className='justify-content-end'>
              <Button
                color="primary"
                style={{ maxWidth: "100px" }}
                onClick={handleGetMetrics}
                id="button-filter"
              >
                Filtrar
              </Button>
            </Row>
          </Form>
        </Row>
      </div>
      <div className='mt-5'>
        {loading ? (
          <div className='d-flex flex-column justify-content-center align-items-center gap-5 mt-5'>
            <BigText>Carregando...</BigText>
            <FillingBottle width="100px" height="100px" color="#dddcdc" />
          </div>
        ) : (
          <Table hover responsive size="" striped className='font-11'>
            <thead className='theme-text-color'>
              <tr>
                <th></th>
                <th style={{ width: "200px" }}>Nome</th>

                {metricType === EnumMetricType.Developer &&
                <th style={{ width: "100px" }}>Data Início</th> }
                
                <th className='pointer' style={{ textAlign: "right" }} onClick={() => handleOrderByAssigned(sortDirectionAssigned)}>
                  {sortDirectionAssigned === 'asc' ?
                    <IoIosArrowUp />
                    :
                    <IoIosArrowDown />
                  }
                  Tarefas Atribuídas

                </th>
                <th className='pointer' style={{ textAlign: "right" }} onClick={() => handleOrderByCompleted(sortDirectionCompleted)}>
                  {sortDirectionCompleted === 'asc' ?
                    <IoIosArrowUp />
                    :
                    <IoIosArrowDown />
                  }
                  {metricType === EnumMetricType.Developer ? 'Tarefas Concluídas' : 'Tarefas Triadas'}

                </th>
                {/* <th style={{ textAlign: "right" }}>Tempo Médio Resolução</th> */}
                <th style={{ textAlign: "right" }}>{metricType === EnumMetricType.Developer ? 'Atribuidas x Concluídas': 'Triadas x Não Triadas'}</th>
              </tr>
            </thead>
            <tbody>
              {metrics?.map((item, index) => (
                <tr key={index} >
                  <td
                    data-tooltip-id="metric-tooltip"
                    data-tooltip-html="Gerar <br/> Relatório"
                    className='pointer'
                  >
                    {/* <BsFillFileEarmarkBarGraphFill onClick={() => handleGetReport(item.Member)} color={"#4893FF"}/> */}
                  </td>
                  <td className='theme-text-color'>  {item.Member.fullName.charAt(0).toUpperCase() + item.Member.fullName.slice(1)}</td>
                  {metricType === EnumMetricType.Developer &&
                  <td className='theme-text-color'>{item.Member.initDate != null ? new Date(item.Member.initDate).toLocaleDateString('pt-BR') : ""}</td>
                  }
                  <td className='td-align-right theme-text-color'>{item.Metrics.TotalTasks}</td>
                  <td className='td-align-right theme-text-color'>{item.Metrics.TotalCompletedTasks}</td>
                  {/* <td className='td-align-right theme-text-color'>{item.Metrics.AverageResolutionTime}h</td> */}
                  <td className='td-align-right theme-text-color'>{item.Metrics.Rating.toFixed(1)}%</td>
                </tr>
              ))}
            </tbody>
          </Table>
        )}
      </div>
      {graphData != null &&
        <div style={{opacity: "0"}}>
          <LineChart member={selectedMember} inputData={graphData} />
          {/* <button onClick={handleDownloadPDF}>Download PDF</button> */}
        </div>
      }
    </div>
  );
}
